import { Component, OnInit }  from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { NgForm }             from '@angular/forms';
import { TranslateService }   from '@ngx-translate/core';

import { AzureSsoService }  from '../../app-lite/azure-sso/azure-sso.service';
import { GoogleSsoService } from '../../app-lite/google-sso/google-sso.service';
import { LoginService }     from './login.service';
import { JsonService }      from '../../app-lite/core/services/json.service';
import { MessagesService }  from '../../app-lite/messages/messages.service';
import { UserModel }        from '../../app-lite/users/typings/user';

@Component({
  selector   : 'wor-login',
  template: require('./login.component.html')
})
export class LoginComponent implements OnInit {
  @BlockUI('loginBlock') block : NgBlockUI;

  user : UserModel = {
    password: '',
    username: ''
  };

  constructor (
    private azureSsoService  : AzureSsoService,
    private googleSsoService : GoogleSsoService,
    private jsonService      : JsonService,
    private loginService     : LoginService,
    private messagesService  : MessagesService,
    private translateService : TranslateService
  ) {}

  login ( form : NgForm ) : void {
    this.messagesService.clearErrors();

    this.block.start();

    this.loginService.login(this.user)
    .catch(error => this.messagesService.error(error))
    .finally(() => this.block.stop());
  }

  loginWithAzure () : void {
    this.block.start();

    this.azureSsoService.getLoginUrl()
    .then(url => window.location.assign(url))
    .catch(error => this.messagesService.error(error))
    .finally(() => this.block.stop());
  }

  ngOnInit () : void {
    const params = this.jsonService.getQueryParameters();

    if ( params.session_state ) {
      this.block.start();

      this.loginService.loginWithXero(window.location.search)
      .catch(error => this.messagesService.error(error))
      .finally(() => this.block.stop());

      return;
    }

    if ( this.googleSsoService.isValidState(params.state) ) {
      const flow = this.googleSsoService.getStoredFlow();

      this.googleSsoService.clearStoredState();

      if ( flow === 'link' && ( params.code || params.error ) ) {
        this.block.start();

        this.googleSsoService.handleLinkFlow(params)
        .then(( url : string ) => window.location.assign(url))
        .catch(( url : string) => window.location.assign(url))
        .finally(() => this.block.stop());

        return;
      }

      if ( flow === 'login' ) {
        if ( params.error ) {
          this.messagesService.error({ message: `${ this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.GOOGLE_SSO.SIGN_IN_FAILED') }: ${ params.error }` });

          return;
        }

        if ( !params.code ) {
          return;
        }

        this.block.start();

        this.loginService.loginWithGoogle(params.code, this.googleSsoService.getRedirectUri())
        .catch(error => {
          this.googleSsoService.errorMessage = error?.message || this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.GOOGLE_SSO.SIGN_IN_FAILED');
        })
        .finally(() => this.block.stop());

        return;
      }
    }
  }
}
